import { AbstractControl, FormGroup } from '@angular/forms';
import { FieldValidationError } from '@rms/sdk/errors';
import { applyFieldErrors } from '@rms/sdk/forms/error';

const SERVER_ERROR_KEY = 'server';
const REJECTED_FIELD_MESSAGE = 'libs.validation.pattern';

/**
 * Marks the fields the API rejected. Its field messages are untranslated,
 * so each gets the generic invalid-format message.
 */
export function applyRejectedFieldErrors(form: FormGroup, error: FieldValidationError): void {
  const messages = Object.fromEntries(Object.keys(form.controls).map((name) => [name, REJECTED_FIELD_MESSAGE]));

  applyFieldErrors(form, error, messages);
}

export function setServerError(control: AbstractControl, message: string): void {
  control.setErrors({ [SERVER_ERROR_KEY]: message });
  control.markAsTouched();
}
